import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of, tap, withLatestFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { DataService } from '../../services/data-api.service';
import { ApiService } from 'src/app/services/api.service';
import { Store } from '@ngrx/store';
import { 
    loadPerformanceLineItem, 
    loadPricingLineItem, 
    loadPerformanceLineItemSuccess, 
    loadPerformanceLineItemFailure, 
    loadPricingLineItemSuccess, 
    loadPricingLineItemFailure 
} from './item-configuration.actions';
import { selectLineItemId } from './item-configuration.selector';

@Injectable()
export class ItemConfigurationEffects {


  
  loadPerformanceLineItem$ = createEffect(() => {
      //console.log('loadPerformanceLineItem$ is happening');
      return this.actions$.pipe(
        ofType(loadPerformanceLineItem),
        withLatestFrom(this.store.select(selectLineItemId)),
        //filter(([_, lineItemId]) => lineItemId && lineItemId.LineItemId > 0), // Only proceed if value is greater than 0
        exhaustMap(([_, lineItemId]) => {

          if (!lineItemId || lineItemId.LineItemId <= 0) {
            //console.log('Invalid LineItemId:', lineItemId);
            return of(loadPerformanceLineItemSuccess({ projectScheduleLineItem: null }));
            //return of(loadPerformanceLineItemFailure({ error: new Error('Invalid LineItemId') }));
          } else {
            //console.log('ngrx effect loading perf line item:', lineItemId);
            return this.apiService.get(`ProjectScheduleLineItem/${lineItemId.LineItemId}`).pipe(
              tap(response => console.log('Search Projects Response:', response)),
              map((response) => {
                  // response.Projects.forEach((project) => project.Brand = brands.find(brand => brand.BrandId === project.BrandId))
                  // event to reduce results to state
                  //console.log('loadPerformanceLineItemSuccess response:', response);
                  return loadPerformanceLineItemSuccess({ projectScheduleLineItem: response })
                }
              ),
              catchError((error) =>
                //event to reduce results to state
                of(loadPerformanceLineItemFailure({ error }))
              )
            );

          }
  
        }
        )
      )
    }
  );


  loadPricingLineItem$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadPricingLineItem),
      withLatestFrom(this.store.select(selectLineItemId)),
      // filter(([_, __, brands]) => brands && brands.length > 0), // Only proceed if brands is not empty
      exhaustMap(([_, lineItemId]) =>
        //this.dataService.searchProject(request).pipe(
        this.apiService.get(`Pricing/GetById/${lineItemId}`).pipe(
          tap(response => console.log('Load pricing line item response:', response)),
          map((response) => {
              // response.Projects.forEach((project) => project.Brand = brands.find(brand => brand.BrandId === project.BrandId))
              // event to reduce results to state
              return loadPricingLineItemSuccess({ projectScheduleLineItemPricing: response })
            }
          ),
          catchError((error) =>
            //event to reduce results to state
            of(loadPricingLineItemFailure({ error }))
          )
        )
      )
    )
  }
);

  constructor(private store: Store, private actions$: Actions, private dataService: DataService, private apiService: ApiService) {
  }
}
